<template>
  <v-layout v-if="cards && group" row wrap align-start class="groupWallWrapper">
    <v-progress-linear :active="false && 'This is a loading indicator that I want hidden for now 2022-09-28'"
      indeterminate color="yellow darken-2" v-if="!group.id || $store.state.loading || groupLoading"></v-progress-linear>
    <v-flex align-center xs12 sm12 md3 lg3 class="groupSidebar text-xs-center"
      :class="{ 'fill-height': $vuetify.breakpoint.mdAndUp }">
      <v-avatar class="amber accent-3 group-avatar" color="#F7C73A" size="137px">
        <v-progress-circular indeterminate color="primary" v-if="groupPhotoLoading"></v-progress-circular>
        <img :src="group.group_photo.large" :key="group.group_photo.large" v-if="group.group_photo.large" />
        <v-icon size="75" v-else>fas fa-users</v-icon>
      </v-avatar>
      <AmazePhotoUpload v-show="false" ref="groupPhotoUpload" v-if="group.my_role == 'admin'" label="Change Photo"
        :btnTrigger="true" accept="png,jpg,gif" v-on:formData="onPhotoChange" />

      <v-layout row wrap align-start>
        <v-flex xs11>
          <div>
            <v-tooltip right top allow-overflow="true" debounce="1" nudge-top="-35" v-if="group.my_role == 'admin'">
              <h3 slot="activator" class="groupName groupNameAdmin py-3" v-on:click="toggleNameInput"
                v-if="!showNameField">
                {{ group.name }}
              </h3>
              <span>Click to edit</span>
            </v-tooltip>
            <h3 slot="activator" class="groupName py-3" v-on:click="toggleNameInput" v-else>
              {{ group.name }}
            </h3>
          </div>
        </v-flex>
        <v-flex xs1 mt-2>
          <v-menu class="cardMenu" bottom left v-if="group.id">
            <v-btn slot="activator" icon><v-icon color="primary">more_vert</v-icon></v-btn>
            <v-list>
              <div>
                <v-list-tile v-if="group.my_role == 'admin'" v-on:click="triggerGroupPhotoUpload">
                  <v-list-tile-title>Change Group Photo</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="group.my_role == 'admin'" v-on:click="togglePublicCheck">
                  <v-list-tile-title>{{ changeAccessText }}</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="leaveGroup()" v-if="group.my_role != 'visitor' && !group.owner">
                  <v-list-tile-title>Leave Group</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="joinGroup()" v-if="group.my_role == 'visitor'">
                  <v-list-tile-title>Join Group</v-list-tile-title>
                </v-list-tile>
                <v-list-tile v-if="this.group.owner || this.$auth.check('uber_admin')" @click="deleteGroup()">
                  <v-list-tile-title>Delete Group</v-list-tile-title>
                </v-list-tile>
              </div>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>

      <v-form v-on:submit.prevent="saveGroup" v-if="showNameField">
        <v-layout>
          <v-flex sm10>
            <v-text-field v-model="group.name" label="" class="edit-in-place" solo></v-text-field>
          </v-flex>
          <v-flex sm1>
            <v-btn @click.enter="saveGroup" color="primary" class="m-0 saveGroupButton">
              <v-icon small>check</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      <hr class="thick" />
      <section class="py-2 groupPermissions">{{ access }}</section>
      <v-btn class="mb-3" color="secondary" @click="joinGroup()" v-if="group.my_role == 'visitor'">Join Group</v-btn>
      <hr class="one-pixel" />

      <section class="py-3" v-if="active">
        <MembersList :key="membersListRefresh" :groupId="$route.params.id" :group="group"
          :canManage="group.my_role == 'admin' || this.$auth.check('uber_admin')" :ownerId="group.creator_id"
          v-if="group && group.id"></MembersList>
      </section>
      <hr class="thick" />

      <v-card class="mt-5" color="#fff">
        <v-layout column align-start class="pa-3">
          <v-flex align-start>
            <v-icon color="secondaryDark" x-large class="mt-2 mb-2 mr-auto">$vuetify.icons.amaze-info</v-icon>
          </v-flex>
          <v-flex class="text-xs-left">
            <p class="text-sm-left">
              Groups can be used to collaborate and share resources such as
              files and website links. All members of the group will see posts
              and comments.
            </p>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="mt-5" color="#fff" v-if="group.my_role !== 'visitor' && $auth.user().allow_activity_email">
        <v-layout column align-start class="pa-3">
          <v-flex align-start>
            <v-icon color="primary" class="mt-2 mb-2 mr-auto">far fa-envelope</v-icon>
          </v-flex>
          <v-flex class="text-xs-left">
            <p class="text-sm-left">
              Group activity notification emails help you stay informed of the latest updates in this group. Use the <em>View Settings</em> button to view and adjust your preferences.
            </p>
          </v-flex>

          <v-dialog v-model="emailSettingsDialog" lazy max-width="800">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" class="ml-0" v-on="on">
                <span>View Settings</span>
              </v-btn>
            </template>

            <v-card color="#fff">
              <v-card-title class="ma-0 pb-0">
                <h3 class="modal-title xs12">Group Activity Notification Email Settings</h3>
              </v-card-title>

              <v-card-text>
                <hr class="thick mb-3" />
                <v-layout column align-start>
                  <v-flex class="text-sm-left">
                    <AmazeActivityEmailControls :group="group" :user="$auth.user()"></AmazeActivityEmailControls>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-card-actions class="py-3">
                <v-btn color="primary" class="ml-1" flat outline @click="emailSettingsDialog = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>

          </v-dialog>
        </v-layout>
      </v-card>
    </v-flex>
    <v-flex xs12 sm12 md9 class="yellow-shade" :class="{ 'fill-height': $vuetify.breakpoint.mdAndUp }">
      <v-layout row wrap :class="{
        'px-4': $vuetify.breakpoint.mdAndDown,
        'px-5': $vuetify.breakpoint.lgAndUp
      }">
        <v-flex xs12 class="pt-3" v-if="!singleCardId">
          <h3 v-if="!singleCardId" class="groupBodyHead">Create New:</h3>
          <section v-if="!singleCardId" class="pt-2">
            <v-btn v-for="type in group.group_type.card_types" :key="type.id" color="primary" class="ml-0 groupTypeBtn"
              :disabled="!type.id" :to="'/group/new-' + type.class + '/' + group.id">
              <v-icon class="groupTypeIcon">{{ type.icon }}</v-icon>
              <span class="groupTypeLabel">{{ type.friendly_name }}</span>
            </v-btn>
          </section>
        </v-flex>
        <v-flex xs12 md8 class="py-1 groupCardsWrapper" align-center>
          <hr v-if="!singleCardId" class="thick" />
          <div class="filterControls">
            <!-- <v-container grid-list-md text-xs-center pb-0> -->
            <v-layout row wrap mt-4 mb-0 v-if="singleCardId">
              <p>
                You are viewing an individual card posted in
                <router-link :to="'/group/' + group.id">{{
                  group.name
                }}</router-link>. If you want to see other cards for this group,
                <router-link :to="'/group/' + group.id">visit the group wall</router-link>.
              </p>
              <!-- <h4 class="text-sm-left mt-2 mb-4">
                  <router-link :to="'/group/' + group.id">View group wall</router-link>
                </h4> -->
            </v-layout>
            <v-layout row wrap mt-4 mb-0 v-else>
              <v-flex xs12 sm5 class="filterKeywordWrapper">
                <v-text-field class="groupFilter" id="keywordFilter" outline clearable v-model="cardsFilter.content"
                  label="Filter Cards" placeholder="Enter keyword to filter cards">
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 class="filterTypeWrapper">
                <v-select v-if="group && group.group_type && group.group_type.card_types
                  " outline :items="cardsTypes" item-value="id" label="Filter by Type" v-model="cardsFilter.cardType"
                  class="groupFilter">
                  <template slot="selection" slot-scope="data">
                    {{ data.item.friendly_name }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ data.item.friendly_name }}
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12 sm3 class="filterOrderWrapper">
                <v-select outline :items="cardsOrder.orders" item-value="id" label="Sort By" v-model="cardsOrder.order"
                  return-object class="groupFilter">
                  <template slot="selection" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }}
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
            <!-- </v-container> -->
            <hr class="thick" />
          </div>
          <div v-if="cards.length === 0" class="pa-4">
            <div v-if="singleCardId">
              <h3 class="mt-3">Card Not Found</h3>
              <p class="mt-3">We were unable to locate this card.</p>
              <p>
                If you want to see other cards for this group,
                <router-link :to="'/group/' + group.id">visit the group wall</router-link>.
              </p>
            </div>
            <div v-else>
              <h3 class="mt-3">Welcome to {{ group.name }}!</h3>
              <p class="mt-3">
                Get started by creating a new discussion question or posting a
                new resource using one of the options above.
              </p>
            </div>
          </div>
          <AmazeCard v-for="card in cards" :key="card.id" :card="card" :group="group" class="my-4"></AmazeCard>
          <div class="text-xs-center mb-4">
            <v-btn color="primary" class="p-2 mb-4 loadMoreButton" v-if="nextPage && !cardsLoading" @click="getGroupCards(group.id, nextPage)">Load More</v-btn>
            <v-progress-circular v-if="cardsLoading" indeterminate color="amber"></v-progress-circular>
          </div>
        </v-flex>
        <v-flex xs12 md3 class="rightGroupSidebar" :class="{ 'mx-4': $vuetify.breakpoint.mdAndUp }">
          <hr class="thick mb-4 hidden-md-and-up" />
          <v-layout column>
            <v-card flat class="pa-3 mb-4 elevation-1 file-manager-card">
              <v-layout column>
                <v-flex>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div>
                        <span class="fa-stack bg-fa-folder fa-1x">
                          <i class="fas fa-circle fa-stack-2x"></i>
                          <i class="far fa-stack-1x fa-inverse fa-folder"></i>
                        </span>
                      </div>
                    </v-flex>
                    <v-flex xs12 mt-2>
                      <p>Access this group's files and upload new files.</p>
                    </v-flex>
                  </v-layout>
                  <v-layout row align-center>
                    <v-flex>
                      <v-btn v-if="group.id" color="primary" class="ml-0"
                        :to="'/group/' + group.id + '/file_manager'">View Files</v-btn>
                    </v-flex>
                  </v-layout>

                  <!--<div v-if="this.$auth.check(['uber_admin','es_admin','coach'])">-->
                  <!--<v-btn class='ml-0 mt-2' :to="'/group/'+group.id+'/manage_folder'">Manage Drive Folder</v-btn>-->
                  <!--</div>-->
                </v-flex>
              </v-layout>
            </v-card>

            <v-flex xs12 v-if="group.training_modules && group.training_modules.length">
              <v-card flat class="pa-3 mb-4 elevation-1">
                <v-layout column>
                  <v-flex>
                    <v-layout row align-center>
                      <v-flex class="shrink mr-3">
                        <v-icon color="secondary" x-large class="mb-2">fas fa-certificate</v-icon>
                      </v-flex>
                      <v-flex>
                        <h4 class="widgetTitle">Learning Modules</h4>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex class="my-4">
                    Access online learning modules related to {{ group.name }}.
                  </v-flex>
                  <v-flex class="groupModuleLinks" v-for="(mod, modIndex) in group.training_modules"
                    :key="'group-modules-' + modIndex">
                    <router-link :to="'/module/' + mod.id">{{ mod.title }} ></router-link>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
  <v-layout v-else row wrap align-start>
    <v-flex align-center xs12 sm4 md3 lg3 class="groupSidebar text-xs-center"
      :class="{ 'fill-height': $vuetify.breakpoint.smAndUp }"></v-flex>
    <v-flex xs12 sm8 md9>
      <v-layout row wrap :class="{
        'px-4': $vuetify.breakpoint.mdAndDown,
        'px-5': $vuetify.breakpoint.lgAndUp
      }">
        <v-flex xs12 class="pt-3">
          <h3>We were unable to locate this group.</h3>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<style scoped lang="scss">
@import "src/styles/variables.scss";

.groupSidebar {
  padding: 30px;

  .group-avatar {
    .v-progress-circular--indeterminate {
      position: absolute;
    }
  }

  .groupName {
    font-size: 22px;
    line-height: 30px;
  }

  .groupName.groupNameAdmin,
  .groupPermissions.groupPermissionsAdmin {
    cursor: pointer;
  }

  .groupPermissions {
    font-size: 20px;
    text-transform: uppercase;
    font-family: $amaze-header-font-stack;
  }
}

.groupBodyHead {
  font-size: 20px;
}

.v-input {
  font-size: 15px !important;
}

.groupTypeLabel {
  padding-left: 0.5em;
}

@media (max-width: 959px) {
  .filterKeywordWrapper {
    margin-right: 0px !important;
    padding-right: 0px !important;
  }

  .filterTypeWrapper {
    margin-right: 0px !important;
    padding-right: 0px !important;
  }
}

.saveGroupButton {
  min-width: auto;
  height: 48px;
  margin: 0;
}

h4 {
  &.widgetTitle {
    margin-top: -10px;
  }
}

::v-deep .list .v-expansion-panel__header {
  padding-left: 0;
  margin-left: 0;
}

@media (min-width: 750px) {
  .glued {
    white-space: nowrap;
  }
}
</style>

<script>
import AmazeCard from "@/components/Widgets/AmazeCard";
import MembersList from "@/components/Widgets/Group/MembersList";
import AmazeActivityEmailControls from '@/components/Widgets/AmazeActivityEmailControls';
import GroupService from "@/services/GroupService";
import AmazePhotoUpload from "@/components/Widgets/AmazePhotoUpload";
import { EventBus } from "@/components/Events/event-bus.js";
import _, { unionBy } from "lodash";

export default {
  components: { AmazeCard, AmazePhotoUpload, MembersList, AmazeActivityEmailControls },
  computed: {
    membersListRefresh() {
      let key = [...[], this.$route.params, this.memberskey];
      return key;
    },
    // a computed getter
    access() {
      if (this.group.public) {
        return "Public Group";
      } else {
        return "Private Group";
      }
    },
    changeAccessText() {
      if (this.group.public) {
        return "Make Private Group";
      } else {
        return "Make Public Group";
      }
    },
    loaded: function () {
      return this.cardsLoading == false && this.groupLoading == false;
    },
    cardsTypes: function () {
      return [{ id: -1, friendly_name: "All Types" }].concat(
        this.group.group_type.card_types
      );
    },
    singleCardId() {
      return this.$route.params.cardId;
    }
  },
  data() {
    return {
      group: {
        group_type: {
          card_types: [{ id: null, class: null }]
        },
        group_photo: { large: false }
      },
      groupLoading: false,
      cards: [],
      cardsFilter: {
        content: null,
        type: null,
        author: null,
        cardType: -1
      },
      memberskey: 0,
      singleCard: false,
      cardsOrder: {
        order: 0,
        orders: [
          {
            id: 0,
            name: "Newest",
            params: "orderBy=created_at&order=desc"
          },
          {
            id: 1,
            name: "Oldest",
            params: "orderBy=created_at&order=asc"
          }
        ]
      },
      cardsLoading: true,
      currentPage: 1,
      nextPage: 1,
      autoLoadPauseThreshold: 4,
      scrolledToBottom: false,
      showNameField: false,
      showPublicCheck: false,
      groupPhotoLoading: false,
      // Using this to manage whether the page is active or not
      // as this is helpful to limit the MemberList getGroupMembers
      // calls that are happening when modules load.
      active: false,
      emailSettingsDialog: false
    };
  },
  methods: {
    triggerGroupPhotoUpload() {
      this.$refs.groupPhotoUpload.fileOnFocus();
    },
    setupPage(groupId) {
      this.$store.commit("loading", { loading: true });
      this.memberskey = this.memberskey++;
      this.cards = [];
      this.currentPage = 1;
      this.nextPage = 1;
      this.scrolledToBottom = false;
      this.showNameField = false;
      this.showPublicCheck = false;
      this.groupPhotoLoading = false;
      this.getGroupInfo(groupId);
      this.getGroupCards(groupId, this.nextPage);
    },
    getGroupInfo(groupId) {
      this.groupLoading = true;
      this.$store.commit("loading", { loading: true });
      this.$http
        .get("groups/" + groupId)
        .then(
          response => {
            this.group = response.data.data;
          },
          response => {
            if (response.status === 403) {
              // permissions error
              this.group = false;
              this.$store.commit("updateMessage", {
                message: "Error accessing group.",
                snackbar: true
              });
            } else {
              // general error
              console.log("Error pulling group info.", response);
            }
          }
        )
        .finally(response => {
          this.groupLoading = false;
          if (this.loaded) {
            this.$store.commit("loading", { loading: false });
          }
        });
    },
    deleteGroup() {
      if (confirm("Are you sure you want to delete this group?")) {
        this.$http.delete("groups/" + this.group.id).then(
          response => {
            this.$router.push({ path: "/dashboard" });
          },
          response => {
            this.$store.commit("updateMessage", {
              message: "Unable to delete this group.",
              snackbar: true
            });
          }
        );
      }
    },
    getGroupCards(groupId, page) {
      this.cardsLoading = true;

      var params = this.singleCardId
        ? "?cardId=" + this.singleCardId
        : "?page=" +
        page +
        (this.cardsFilter && this.cardsFilter.content
          ? "&content=" + encodeURIComponent(this.cardsFilter.content)
          : "") +
        (this.cardsFilter &&
          this.cardsFilter.cardType &&
          this.cardsFilter.cardType > 0
          ? "&cardType=" + encodeURIComponent(this.cardsFilter.cardType)
          : "") +
        (this.cardsOrder && this.cardsOrder.order
          ? "&" + this.cardsOrder.order.params
          : "") +
        "";

      this.$http
        .get("cards/group/" + groupId + params)
        .then(
          response => {
            const data = response.body.data;
            this.currentPage = data.current_page;
            this.nextPage =
              data.last_page >= this.currentPage + 1
                ? this.currentPage + 1
                : false;
            // this.cards = unionBy(data.data, this.cards, 'id');
            // this.cards = orderBy(unionBy(data.data, this.cards, 'id'), 'id', 'desc');
            // this.cards = this.cards.concat(data.data);
            this.cards = unionBy(this.cards, data.data, "id");
            this.$store.commit("loading", { loading: false });
            if (this.nextPage && this.scrolledToBottom) {
              this.getGroupCards(groupId, this.nextPage);
            }
          },
          response => {
            if (response.status === 403) {
              // permissions error
              this.cards = false;
              this.cardsLoading = false;
              this.$store.commit("updateMessage", {
                message: "Error accessing cards for group.",
                snackbar: true
              });
            } else {
              // general error
              console.log("Error pulling group card.", response);
            }
          }
        )
        .finally(response => {
          this.cardsLoading = false;
          if (this.loaded) {
            this.$store.commit("loading", { loading: false });
          }
        });
    },
    bottomVisible() {
      // I need to make this trigger when the load more button is visible.
      const loadMoreButton = document.querySelector(".loadMoreButton");

      if (!loadMoreButton) {
        return false;
      }

      const rect = loadMoreButton.getBoundingClientRect();
      const bottomOfPage = rect.top < window.innerHeight;
      return bottomOfPage;
    },
    handleScroll() {
      this.scrolledToBottom = this.bottomVisible();
    },
    createNewCard(cardTypeId) {
      let newCard = {
        name: "My Great Card",
        card_type_id: cardTypeId,
        user_id: this.$auth.user().id,
        allow_comments: 1,
        allow_likes: 1,
        groups: [this.$route.params.id]
      };
      this.$http.post("cards", newCard).then(
        response => {
          this.cards.unshift(response.data.data);
        },
        response => {
          console.log("Error creating card.");
        }
      );
    },
    saveGroup() {
      let updatedGroup = {
        name: this.group.name,
        group_type: this.group.group_type,
        group_type_id: this.group.group_type_id,
        public: this.group.public
      };
      this.$http.put("groups/" + this.$route.params.id, updatedGroup).then(
        response => {
          console.log("Changes saved.");
          this.$store.commit("updateGroups");
        },
        response => {
          console.log("Error updating group.");
        }
      );
      this.showNameField = false;
    },
    joinGroup() {
      return GroupService.joinGroup(
        this.group.id,
        this.$auth.user().id,
        2
      ).then(
        response => {
          // get body data
          this.response = response;
          this.setupPage(this.$route.params.id);
          this.$store.commit("updateGroups");
        },
        response => {
          console.error("[error] joinGroup");
        }
      );
    },
    leaveGroup() {
      let leaveData = {
        group_id: this.group.id,
        user_id: this.$auth.user().id
      };
      this.$http.post("groups/leave", leaveData).then(
        response => {
          this.$store.commit("updateGroups");
          this.$router.push({ path: "/" });
        },
        respose => {
          console.error("[error] leaveGroup");
        }
      );
    },
    onPhotoChange(formData) {
      this.group.group_photo = {};
      this.groupPhotoLoading = true;
      this.$http
        .post("groups/photo/" + this.$route.params.id, formData)
        .then(
          response => {
            this.$store.commit("updateMessage", {
              message: "Group photo saved.",
              snackbar: true
            });
            this.$store.commit("updateGroups");
            this.getGroupInfo(this.$route.params.id);
          },
          response => {
            this.$store.commit("updateMessage", {
              message: "Error saving photo.",
              snackbar: true
            });
            console.log("Error saving photo.");
          }
        )
        .finally(response => {
          this.groupPhotoLoading = false;
        });
    },
    toggleNameInput() {
      if (this.group.my_role === "admin") {
        this.showNameField = !this.showNameField;
      } else {
        this.showNameField = false;
      }
    },
    togglePublicCheck() {
      if (this.group.my_role === "admin") {
        this.group.public = !this.group.public;
        this.saveGroup();
      }
    },
    debouncedGetGroupCards: _.debounce(function (groupId, page) {
      this.cards = [];
      this.currentPage = 1;
      this.nextPage = 1;
      this.getGroupCards(groupId, page);
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.$store.state.loading) {
        vm.$store.commit("loading", { loading: true });
        vm.setupPage(to.params.id);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (!this.$store.state.loading) {
      this.$store.commit("loading", { loading: true });
      this.setupPage(to.params.id);
    }
    next(); // LEAVE HERE, beforeRouteUpdate doesn't have the same next() callback like beforeRouteEnter
  },
  watch: {
    // whenever question changes, this function will run
    cardsFilter: {
      handler: function (n, o) {
        this.debouncedGetGroupCards(this.$route.params.id, 1);
      },
      deep: true
    },
    // whenever question changes, this function will run
    cardsOrder: {
      handler: function (n, o) {
        this.debouncedGetGroupCards(this.$route.params.id, 1);
      },
      deep: true
    },
    scrolledToBottom(bottom) {
      // Initially, this should run at most [autoLoadPauseThreshold - 1] times.
      // Once the [autoLoadPauseThreshold] iteration happens,
      // I want it to pause and force the user to press the "Load More" button.
      // After that, functionality resumes as normal.
      // This is to give mobile users the ability to
      // access the file manager and other sidebar items
      // even if the group has a lot of cards. A bit of a workaround
      // to allow infinite scroll but also allow access to other
      // group features and the site footer.
      if (this.nextPage && this.nextPage !== this.autoLoadPauseThreshold && bottom) {
        this.getGroupCards(this.$route.params.id, this.nextPage);
      }
    }
  },
  activated() {
    this.active = true;
    if (!this.$store.state.loading) {
      this.$store.commit("loading", { loading: true });
      this.setupPage(this.$route.params.id);
    }
    // Moved this to activate from created. We want to
    // be able to add/remove this listener on route updates.
    window.addEventListener("scroll", this.handleScroll);
  },
  deactivated() {
    this.active = false;
    // Moved this to activate from destroyed. We want to
    // be able to add/remove this listener on route updates.
    window.removeEventListener("scroll", this.handleScroll);
  },
  created() {
    this.$store.commit("loading", { loading: true });
    this.setupPage(this.$route.params.id);

    if (this.singleCardId) {
      EventBus.$on("card-deleted", (card, group) => {
        this.$router.push({ path: "/group/" + group.id });
      });
    } else {
      EventBus.$on("refresh-cards", (groupId, all, reset) => {
        if (!groupId) {
          console.warn(
            "[refresh-cards] Event was emitted without the required `groupId`."
          );
        }

        if (reset === true) {
          all = true;
          this.cards = [];
          this.currentPage = 1;
          this.nextPage = 1;
        }
        this.getGroupCards(groupId, all ? 1 : this.nextPage);
      });
    }
  },
  destroyed() { }
};
</script>
